<div class="dropdown-container">

    <!-- Disable the dropdown button entirely when the dropdown is disabled -->
    <button (click)="toggleDropdown()" class="dropdown-trigger" [disabled]="isDropdownDisabled">
        <span *ngIf="selectedFilter?.length > 0">
            {{ selectMode === 'multi' ? selectedFilter.length + ' selected' : selectedFilter[0]?.value }}
        </span>
        <span *ngIf="selectedFilter?.length === 0">
            Select
        </span>
        <uitk-icon id="star-down" class="dropdown-arrow rotate-arrow" iconName="arrow_back_ios"></uitk-icon>
    </button>

    <!-- Only show the dropdown if it's not disabled -->
    <div *ngIf="dropdownOpen && !isDropdownDisabled" class="dropdown-content">
        <!-- Search Box inside the dropdown -->
        <input type="text" [(ngModel)]="searchQuery" (input)="onSearch(searchQuery)" placeholder="Search"
            class="search-box" [disabled]="isSearchBoxDisabled || isDropdownDisabled">

        <!-- Add Select All checkbox for multi-select mode -->
        <div *ngIf="selectMode === 'multi'" class="dropdown-item">
            <label>
                <input type="checkbox" [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()"
                    [checked]="isSelectAllChecked()" [disabled]="isDropdownDisabled">
                Select All
            </label>
        </div>

        <!-- List of filtered items -->
        <div *ngFor="let item of filteredItems" class="dropdown-item">
            <span>
                <!-- For multi-select, checkboxes will be shown -->
                <input type="checkbox" *ngIf="selectMode === 'multi'" [checked]="isSelected(item)"
                    (change)="toggleSelection(item)" [disabled]="item.disabled || isDropdownDisabled">

                <!-- For single select, no checkboxes -->
                <span *ngIf="selectMode === 'single'" (click)="toggleSelection(item)"
                    [ngClass]="{'disabled-option': item.disabled || isDropdownDisabled}">
                    {{ item.value }}
                </span>

                <!-- Label for the item (display only 'value' key) -->
                <span *ngIf="selectMode === 'multi'"
                    [ngClass]="{'disabled-option': item.disabled || isDropdownDisabled}">
                    {{ item.value }}
                </span>
            </span>
        </div>
    </div>
</div>